module.exports = __webpack_public_path__ + "static/img/img11.2a0837ab.png";